export default __webpack_public_path__ + "static/media/TL.2632cee8.svg";